module.exports = __webpack_public_path__ + "r-v3/img/search.dc32d1dc.svg";